import { mobileSliderInit } from '../functions'
import { Autoplay } from "swiper/modules";

mobileSliderInit(".freelance__slider", {
    media: 768,
    sliderOptions: {
        modules: [Autoplay],
        autoplay: true,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
            500: {
                slidesPerView: 1.5,
            },
        },
    },
});
